import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import { useAtomValue } from 'jotai';

import Alert from '@mui/material/Alert';

import { geoAtom } from 'v2/atoms/geoAtom';
import { Geo, GEO_AFFECTED_ROUTES } from 'v2/constants';
import { AppRoute } from 'v2/routes';

const geoDescriptionMap: Record<Geo, string> = {
  [Geo.RU]: 'RU',
  [Geo.KZ]: 'KZ',
};

interface GeoContextBadgeProps {
  forceShow?: boolean;
}

export const GeoContextBadge = memo<GeoContextBadgeProps>(({ forceShow = false }) => {
  const { pathname } = useLocation();
  const geo = useAtomValue(geoAtom);

  const isAffected = forceShow || GEO_AFFECTED_ROUTES.includes(pathname as AppRoute);

  if (!isAffected) {
    return null;
  }

  return (
    <Alert severity={geo === Geo.KZ ? 'warning' : 'info'} variant="filled">
      Вы редактируете данные гео: {geoDescriptionMap[geo]}
    </Alert>
  );
});

GeoContextBadge.displayName = 'GeoContextBadge';
